'use strict';

var balcaoApp = angular.module('detalheChamadoMdl');
balcaoApp.factory('detalheChamadoApi', detalheChamadoSrv);
detalheChamadoSrv.$inject = ['$resource', 'ConfigApp'];

function detalheChamadoSrv($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/meus_chamados',
        {  }, {
            verificarRespostas: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/atendimentos/:chamadoAtendimentoId/respostas'
            },
            redirecionamentos: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/roteamentos/chamados/:chamadoId',
                params: { chamadoId: '@chamadoId' }
            }
        });
};



// WEBPACK FOOTER //
// ./src/modules/detalhe-chamado/detalhe-chamado-api-service.js